<!-- Instructions -->
<div class="max-w-xl mb-3">
	<ul class="list-disc pl-5 mb-2 text-sm">
		<li class="pb-3">Full visibility into your plan, billing cycle and current account usage.</li>
		<li class="pb-3">
			For guidance on using Tyalls and understanding access, visit the
			<a href="{{this.supportHubLink}}" target="_blank" class="underline cursor-pointer">
				Support Hub
			</a>
		</li>
	</ul>
</div>

<!-- Account Information (child) -->
<app-account-information
	[isLoading]="isInfoLoading()"
	[planName]="planName()"
	[commencementDate]="commencementDate()"
	[accountOwner]="accountOwner()"
	[planDetails]="planDetails()"
	[features]="features()"
	[billingCycle]="billingCycle()"
	[pms]="pms()"
	[propertyName]="propertyName()"
	[remainingDaysLeft]="remainingDaysLeft()"
>
</app-account-information>

<!-- Active Features & Access (child) -->
<app-active-features-access
	[isListsLoading]="isListsLoading()"
	[isAiActivatedTasksLoading]="isAiActivatedTasksLoading()"
	[activeGroups]="activeGroups()"
	[activeUsers]="activeUsers()"
	[noActiveGroups]="noActiveGroups()"
	[noActiveUsers]="noActiveUsers()"
	[aiTasksActivated]="aiTasksActivated()"
	[aiTasksActivatedCount]="aiTasksActivatedCount()"
	[addOns]="addOns()"
	(download)="downloadSummaryXlsx()">
</app-active-features-access>
